module.exports = __webpack_public_path__ + "media/images/img-8a671cce40da91c41962b403d9989f84.png";